// extracted by css-extract-rspack-plugin
export default {"bannerLink":"navigation-fragment__ACMBanner_bannerLink__UJQhp","skeleton":"navigation-fragment__ACMBanner_skeleton__vNuTH"};